import React, { useRef, useEffect, useState } from "react";
import shap from "./../images/after.png";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import R from "../assets/images/model/uparrow.svg";

import "react-big-calendar/lib/css/react-big-calendar.css";
import "react-big-calendar/lib/addons/dragAndDrop/styles.css";

import CustomCell from "./CustomCell";

const localizer = momentLocalizer(moment);
const Modal = ({
  handleCalnendarShow,
  isDraggingActivity,
  draggedActivity,
  setDraggedActivityPosition,
  setIsDraggingActivity,
  showCalendar,
  setShowCalendar,
  book,
  setSelectedActivity,
  selectedActivity,
  setActivities,
}) => {
  const [isDragging, setIsDragging] = useState(false);
  const [draggedEvent, setDraggedEvent] = useState(null);
  const [position, setPosition] = useState({ top: 0, left: 0 });
  const [draggedOverDate, setDraggedOverDate] = useState(null);
  const [className, setClassName] = useState("d-none");

  // const currentDate = new Date();

  // const year = currentDate.getFullYear().toString().slice(-2);
  // const formattedDate = `${currentDate.toLocaleString("default", {
  //   month: "short",
  // })} ${year}`;

  const positionSetter = (x, y) => {
    setPosition({
      top: y,
      left: x,
    });
  };
  const draggedEventSetter = (value) => {
    setDraggedEvent(value);
  };
  const isDraggingSetter = (value) => {
    setIsDragging(value);
  };

  // Custom Event Component

  //   const CustomRow = ({ children }) => {
  //   // Add your custom row rendering logic here
  //   return <div className="custom-row">
  //       check this
  //       {children}
  //     </div>;
  // };

  const CustomDaysHeader = ({ date }) => {
    // Custom days header component logic...
    return (
      <div className="custom-days">
        {/* Render your custom days header */}
        
        {date.toLocaleDateString()}
      </div>
    );
  };

  const cModalRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      const calendarBtn = document.getElementById("calendar-button");
      if (
        // showCalendar &&
        event.target !== calendarBtn &&
        cModalRef.current &&
        !cModalRef.current.contains(event.target) &&
        !event.target.classList.contains("activity-element")
      ) {
        // Click is outside of element x and not on elements with class 'y'
        // Execute your statement here
        setShowCalendar(false);
        document.removeEventListener("click", handleClickOutside);
      }
    };
    if (showCalendar) {
      document.addEventListener("click", handleClickOutside);
    }

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [showCalendar]);

  let timerId2 = null;
  useEffect(() => {
    if (!showCalendar) {
      timerId2 = setTimeout(() => {
        setClassName("d-none");
      }, 400); // Delay of 0.5 seconds (500 milliseconds)
    } else {
      setClassName("");
    }
    return () => {
      clearTimeout(timerId2); // Clean up the timeout on component unmount or state change
    };
  }, [showCalendar]);

  return (
    <div
      // className="calander_Wrap"
      ref={cModalRef}
      className={`calander_Wrap ${
        showCalendar === undefined
          ? ""
          : !showCalendar
          ? `animate-down`
          : "animate-up"
      } ${className}`}
      style={{
        display: showCalendar === undefined ? "none" : "",
      }}
    >
      <div>
        <img
          src={shap}
          alt="calander_img"
          className="cursor calander_img"
          onClick={(e) => handleCalnendarShow(false)}
        />
        <div
          className="calander_modal_inner"
          onMouseMove={(e) => {
            e.preventDefault();
            if (isDragging) {
              setPosition({
                top: e.clientY,
                left: e.clientX,
              });
            }
            if (isDraggingActivity) {
              setDraggedActivityPosition({
                top: (e.clientY / window.innerHeight) * 100,
                left: (e.clientX / window.innerWidth) * 100,
              });
            }
          }}
          onMouseUp={(e) => {
            if (isDragging) {
              setIsDragging(false);
            }
            if (isDraggingActivity) {
              setIsDraggingActivity(false);
            }
          }}
        >
          <Calendar
            localizer={localizer}
            defaultView="month"
            components={{
              dateCellWrapper: (props) => (
                <CustomCell
                  {...props}
                  position={position}
                  isDragging={isDragging}
                  draggedEvent={draggedEvent}
                  setPosition={positionSetter}
                  setIsDragging={isDraggingSetter}
                  draggedActivity={draggedActivity}
                  draggedOverDate={draggedOverDate}
                  setDraggedEvent={draggedEventSetter}
                  setDraggedOverDate={setDraggedOverDate}
                  isDraggingActivity={isDraggingActivity}
                  book={book}
                  setSelectedActivity={setSelectedActivity}
                  selectedActivity={selectedActivity}
                  setActivities={setActivities}
                />
              ),
              month: {
                weekHeader: CustomDaysHeader,
              },
              toolbar: ({ onNavigate, date }) => (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "25px",
                  }}
                >
                  <img
                    src={R}
                    alt="left_arrow"
                    className="cursor"
                    onClick={() => onNavigate("PREV")}
                    style={{
                      rotate: "-90deg",
                      padding: "7px",
                      borderRadius: "50%",
                      background: "#E6E5E4",
                    }}
                  />
                  <h1
                    className="title_date cursor"
                    onClick={() => handleCalnendarShow(false)}
                  >
                    {`${date.toLocaleString("default", {
                      month: "short",
                    })} ${date.getFullYear().toString().slice(-2)}`}
                  </h1>
                  <img
                    src={R}
                    alt="right_arrow"
                    className="cursor"
                    onClick={() => {
                      onNavigate("NEXT");
                    }}
                    style={{
                      rotate: "90deg",
                      padding: "7px",
                      borderRadius: "50%",
                      background: "#E6E5E4",
                    }}
                  />
                </div>
              ),
              // timeSlotWrapper: CustomRow
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default Modal;
